var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout"},[_c('el-row',[_c('el-col',[_c('p',{staticStyle:{"text-align":"center","margin-top":"30px"}},[_vm._v("ログアウトしました。")])])],1),_c('el-row',[_c('el-col',{staticStyle:{"text-align":"center"}},[_c('router-link',{attrs:{"to":"/login"}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("ログインページへ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }